import { Formik } from "formik";
import { Button, Container, Form, Row } from "reactstrap";
import { validationForOffer } from "./constants/validationSchema";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  isEmptyOrInvalidField,
  isEmptyorInvalidFieldForGrantsAndCharges,
  optionsForSelect,
  handleStartDateChange,
  uomOptionsForUsage,
  resourceArrayData,
  grantArrayData,
  chargeArrayData,
  serviceDataOptions,
  policyDataOptions,
  aggregateResourceDataOptions,
} from "./constants/checkEmptyFields";
import {
  TimePeriodOptions,
  recurringFrequencyOptions,
  infiniteOptions,
  TimePeriodEndOptions,
} from "./constants/initialValues";
import {
  handleSelectedService,
  handleChargesProrateState,
  handleProrateState,
  handleGrantsOverrideState,
  handleChargesOverrideState,
  handleGrantsRecurringOverride,
  handleChargesRecurringOverride,
  toggleAccordion,
} from "./constants/displayInfinite";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllUom } from "../../../slices/uom/thunk";
import { getAllResources } from "../../../slices/resources/thunk";
import { getAllService } from "../../../slices/services/thunk";
import { ToastContainer } from "react-toastify";
import { Loader } from "../../Utils/Loader";
import { onSubmtiFunctionForOffer } from "./constants/GrantsAndRecurringFunctions";
import CommonButton from "../../Utils/CommonButton";
import { getOffer } from "../../../slices/offer/getoffer/thunk";
import { customerIdData } from "../../Customers/constants/constantFunctionsView";
import { PAGE_TITLES } from "../../Common/constants";
import { getAllPolicies } from "../../../slices/Policy/thunk";
import { getAggregateResource } from "../../../slices/resources/AggregateResource/thunk";
import { getAllAttribute } from "../../../slices/services/addservice/provisionalattribute/thunk";
import ViewOffer from "./ViewOffer";
import { CreateOfferContext, ViewOfferContext } from "./context";
import AddOfferContent from "./AddOfferContent";
import AddOfferFooter from "./AddOfferFooter";
import { fetchAllUsageEventType } from "../../../slices/usageEventType/thunk";
import { getAllChargeRule } from "../../../slices/ChargeRule/thunk";

export default function AddOffer() {
  const [state, setState] = useState(false);
  const [stateCharges, setStateCharges] = useState(false);
  const [overrideCharge, setOverrideCharge] = useState(false);
  const [overrideChargeRecurring, setOverrideChargeRecurring] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [globalState, setGlobalState] = useState(false);
  const [addOnState, setAddOnState] = useState(false);
  const [serviceBarringState, setServiceBarringState] = useState(false);
  const [serviceCode, setServiceCode] = useState("");
  const [activeMainTab, setActiveMainTab] = useState(1);
  const [activeTab, setActiveTab] = useState("1");
  const [chargesActiveTab, setChargesActiveTab] = useState("1");
  const [usageActiveTab, setUsageActiveTab] = useState("1");
  const [open, setOpen] = useState("1");
  const [prorateState, setProrateState] = useState(false);
  const [overrideState, setOverrideState] = useState(false);
  const [overrideStateRecurring, setOverrideStateRecurring] = useState(false);
  const [selectedService, setSelectedService] = useState([]);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [stop, setStop] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [disableValidityInGrantOne, setDisableValidityInGrantOneTime] =
    useState([]);
  const [disableValidityInGrantRecurring, setDisableValidityInGrantRecurring] =
    useState([]);
  const [rollover, setRollover] = useState([]);
  const sectionRefs = useRef({});
  const rightContentRef = useRef(null);

  const [initialValues, setInitialValues] = useState({
    offerName: "",
    offerCode: "",
    offerPriority: "",
    subscriptionStartsOn: "",
    timePeriodStart: 1,
    timePeriodOptionStart: TimePeriodOptions[0],
    subscriptionEndsOn: "",
    timePeriod: 1,
    timePeriodOption: TimePeriodEndOptions[0],
    description: "",
    offerStartsOn: null,
    offerEndsOn: null,
    usageId: "1",
    eventType: "",
    resourceName: "",
    unitOfMeasurement: "",
    priority: "1",
    perUnitRate: "",
    flatRate: "",
    serviceName: "",
    policyName: "",
    aggregateVolume: [],
    usageRatePlan: [],
    recurringUsageRatePlan: [],
    grants: [],
    recurringGrants: [],
    charges: [],
    recurringCharges: [],
    effectiveAt: null,
    pricingModel: [],
    categories: "",
  });
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const offerCode = customerIdData();
  const isClone = location.pathname.includes("clone-offer");
  const isEdit = location.pathname.includes("update-offer");
  const isCreate = location.pathname.includes("create-offer");
  const isView = location.pathname.includes("view-offer");
  const [formValues, setFormValues] = useState(initialValues);
  const toggle = toggleAccordion(open, setOpen, globalState);
  const [triggerError, setTriggerError] = useState(false);

  let prorateStateArray = [];
  let uomArray = [];
  let resourceNameArray = [];
  let grantResourceTypeArray = [];
  let chargeResourceTypeArray = [];

  useEffect(() => {
    dispatch(fetchAllUom(setLoading));
    dispatch(fetchAllUsageEventType(setLoading));
    dispatch(getAllResources(setLoading));
    dispatch(getAllPolicies(setLoading));
    dispatch(getAggregateResource(setLoading));
    dispatch(getAllService(setLoading));
    dispatch(getAllAttribute(setLoading));
    dispatch(getAllChargeRule(setLoading));
  }, [dispatch]);

  useEffect(() => {
    if (isEdit) {
      setTitle(PAGE_TITLES.EDIT_OFFER);
    } else if (isClone) {
      setTitle(PAGE_TITLES.CLONE_OFFER);
    } else if (isView) {
      setTitle(PAGE_TITLES.VIEW_OFFER);
    } else {
      setTitle(PAGE_TITLES.ADD_OFFER);
    }
  }, [isEdit]);

  const uomData = useSelector((state) => state.Uom.uom);
  const resourceData = useSelector((state) => state.Resources.resources);
  const serviceData = useSelector((state) => state.Services.services);
  const Policies = useSelector(
    (state) => state?.GetAllPolicies?.getAllPolicies
  );
  const aggregateResource = useSelector(
    (state) => state?.GetAggregateResource?.aggregateResources
  );
  let serviceOptions = serviceDataOptions(serviceData);
  let policiesOptions = policyDataOptions(Policies);
  let aggregateResourceOptions =
    aggregateResourceDataOptions(aggregateResource);
  let resourceNameOptions = optionsForSelect(
    resourceArrayData(resourceData, resourceNameArray)
  );
  let uomOptions = optionsForSelect(uomOptionsForUsage(uomData, uomArray));
  let grantResourceOptions = optionsForSelect(
    grantArrayData(resourceData, grantResourceTypeArray)
  );
  let chargeResourceOptions = optionsForSelect(
    chargeArrayData(resourceData, chargeResourceTypeArray)
  );

  const attributes = useSelector((state) => state.Provisional.provisional);
  const chargeRules = useSelector((state) => state?.ChargeRule?.chargeRule);

  //UPDATE
  useEffect(() => {
    if ((isEdit || isClone || isView) && serviceData && serviceData.length) {
      dispatch(
        getOffer(
          setLoading,
          offerCode,
          isEdit || isView,
          initialValues,
          setInitialValues,
          resourceData,
          serviceData,
          formValues,
          setFormValues,
          setStop,
          stop,
          setDisableValidityInGrantOneTime,
          setDisableValidityInGrantRecurring
        )
      );
    }
  }, [serviceData]);

  const getOfferData = useSelector((state) => state.GetOffer.editOffer);

  useEffect(() => {
    if (globalState) {
      setOpen(false);
    }
  }, [globalState, getOfferData]);

  useEffect(() => {
    if (isEdit || isClone || isView) {
      setGlobalState(getOfferData?.globalScope || false);
      setAddOnState(getOfferData?.addOnOffer || false);
      setServiceBarringState(
        getOfferData?.serviceBarringUponRenewalFailure || false
      );
      setState(
        getOfferData?.validity?.to === "0001-01-01T00:00:00Z" ? true : false
      );
      setIsSubscribed(getOfferData?.isSubscribed);
    }
  }, [isEdit, isClone, getOfferData]);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={validationForOffer(
          state,
          isEdit,
          isClone,
          disableValidityInGrantOne,
          disableValidityInGrantRecurring
        )}
        onSubmit={onSubmtiFunctionForOffer(
          dispatch,
          selectedService,
          resourceData,
          state,
          globalState,
          serviceCode,
          setLoading,
          navigate,
          isEdit,
          serviceData,
          addOnState,
          isClone,
          attributes,
          setTriggerError,
          serviceBarringState
        )}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          setFieldTouched,
          setFieldValue,
          setTouched,
          resetForm,
          isSubmitting,
        }) => (
          <Form id="csms" className="needs-validation" onSubmit={handleSubmit}>
            <div className="page-content bg-white">
              <Container fluid>
                <BreadCrumb title={title} pageTitle={PAGE_TITLES.OFFER_LIST} />
                <div className="d-flex">
                  <h5 className="rv-page-title p-0 ps-2">
                    {isView
                      ? "View Offer"
                      : isClone
                      ? "Clone Offer"
                      : isEdit
                      ? "Edit Offer"
                      : "Add Offer"}
                  </h5>
                  {isView && (
                    <Button
                      color="secondary"
                      className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 text-nowrap mt-0 ms-auto"
                      onClick={() => {
                        navigate(`/update-offer/${offerCode}`);
                      }}
                    >
                      <i className="ri-edit-box-line label-icon align-middle fs-16 me-2"></i>
                      <span className="px-0 ps-2 ms-2 me-1">Edit</span>
                    </Button>
                  )}
                </div>
                <ToastContainer position="top-center" />
                {isView ? (
                  <ViewOfferContext.Provider
                    value={{
                      values,
                      isOfferNeverExpires: state,
                      globalState,
                      serviceBarringState,
                      sectionRefs: sectionRefs,
                      rightContentRef: rightContentRef,
                    }}
                  >
                    <ViewOffer />
                  </ViewOfferContext.Provider>
                ) : (
                  <CreateOfferContext.Provider
                    value={{
                      values: values,
                      setFormValues: setFormValues,
                      touched: touched,
                      isEdit: isEdit,
                      errors: errors,
                      isSubscribed: isSubscribed,
                      handleBlur: handleBlur,
                      handleChange: handleChange,
                      state: state,
                      setState: setState,
                      startDate: startDate,
                      setStartDate: setStartDate,
                      handleStartDateChange: handleStartDateChange,
                      setFieldTouched: setFieldTouched,
                      setFieldValue: setFieldValue,
                      TimePeriodOptions: TimePeriodOptions,
                      globalState: globalState,
                      addOnState: addOnState,
                      setGlobalState: setGlobalState,
                      setAddOnState: setAddOnState,
                      serviceBarringState,
                      setServiceBarringState,
                      serviceData: serviceData,
                      setServiceCode: setServiceCode,
                      setSelectedService: setSelectedService,
                      serviceOptions: serviceOptions,
                      policiesOptions: policiesOptions,
                      aggregateResourceOptions: aggregateResourceOptions,
                      handleSelectedService: handleSelectedService,
                      sectionRefs: sectionRefs,
                      rightContentRef: rightContentRef,
                      activeMainTab: activeMainTab,
                      setActiveMainTab: setActiveMainTab,
                      activeTab,
                      setActiveTab,
                      chargesActiveTab,
                      setChargesActiveTab,
                      usageActiveTab,
                      setUsageActiveTab,
                      isCreate: isCreate,
                      disableValidityInGrantOne: disableValidityInGrantOne,
                      setDisableValidityInGrantOneTime:
                        setDisableValidityInGrantOneTime,
                      disableValidityInGrantRecurring:
                        disableValidityInGrantRecurring,
                      setDisableValidityInGrantRecurring:
                        setDisableValidityInGrantRecurring,
                      loading: loading,
                      setLoading: setLoading,
                      open: open,
                      toggle: toggle,
                      resourceData: resourceData,
                      prorateState: prorateState,
                      setProrateState: setProrateState,
                      prorateStateArray: prorateStateArray,
                      overrideState: overrideState,
                      setOverrideState: setOverrideState,
                      overrideStateRecurring: overrideStateRecurring,
                      setOverrideStateRecurring: setOverrideStateRecurring,
                      handleProrateState: handleProrateState,
                      handleGrantsOverrideState: handleGrantsOverrideState,
                      handleChargesProrateState: handleChargesProrateState,
                      handleChargesOverrideState: handleChargesOverrideState,
                      handleGrantsRecurringOverride:
                        handleGrantsRecurringOverride,
                      handleChargesRecurringOverride:
                        handleChargesRecurringOverride,
                      infiniteOptions: infiniteOptions,
                      grantResourceOptions: grantResourceOptions,
                      setTouched: setTouched,
                      stateCharges: stateCharges,
                      setStateCharges: setStateCharges,
                      overrideCharge: overrideCharge,
                      setOverrideCharge: setOverrideCharge,
                      overrideChargeRecurring: overrideChargeRecurring,
                      setOverrideChargeRecurring: setOverrideChargeRecurring,
                      recurringFrequencyOptions: recurringFrequencyOptions,
                      chargeResourceOptions: chargeResourceOptions,
                      isEmptyOrInvalidField: isEmptyOrInvalidField,
                      resourceNameOptions: resourceNameOptions,
                      uomOptions: uomOptions,
                      isEmptyorInvalidFieldForGrantsAndCharges:
                        isEmptyorInvalidFieldForGrantsAndCharges,
                      isClone: isClone,
                      isSubmitting: isSubmitting,
                      rollover: rollover,
                      setRollover: setRollover,
                      attributes: attributes,
                      chargeRules: chargeRules,
                      triggerError,
                    }}
                  >
                    <AddOfferContent />
                    <AddOfferFooter />
                  </CreateOfferContext.Provider>
                )}
              </Container>
            </div>
          </Form>
        )}
      </Formik>
      {loading && <Loader />}
    </div>
  );
}
